import Career from "."; 

export const careerRoutes = () => [
  {
    path: "/careers",
    component: Career,
    layout: "front",
    title: "page",
  },
];